import { Suspense, lazy } from 'react'

import { AnnualReviewDetails } from '~bank-annual-review/types/AnnualReviewDetails'

const QuestionnaireComponents = {
  Questionnaire1: lazy(() => import('./components/Questionnaire1').then((m) => ({ default: m.Questionnaire1 }))),
  Questionnaire2: lazy(() => import('./components/Questionnaire2').then((m) => ({ default: m.Questionnaire2 }))),
  Questionnaire3: lazy(() => import('./components/Questionnaire3').then((m) => ({ default: m.Questionnaire3 }))),
  QuestionnaireDemo: lazy(() =>
    import('./components/QuestionnaireDemo').then((m) => ({ default: m.QuestionnaireDemo }))
  )
}

type Props = {
  data: AnnualReviewDetails
}

export const Questionnaire = (props: Props) => {
  const { data } = props

  return (
    <Suspense fallback={<div>Loading questionnaire...</div>}>
      <div id="annual-review-q">
        {data?.showQuestionnaire1 && <QuestionnaireComponents.Questionnaire1 questionnaire={data.showQuestionnaire1} />}
        {data?.showQuestionnaire2 && <QuestionnaireComponents.Questionnaire2 questionnaire={data.showQuestionnaire2} />}
        {data?.showQuestionnaire3 && <QuestionnaireComponents.Questionnaire3 questionnaire={data.showQuestionnaire3} />}
        {data?.showQuestionnaireDemo && (
          <QuestionnaireComponents.QuestionnaireDemo questionnaire={data.showQuestionnaireDemo} />
        )}
      </div>
    </Suspense>
  )
}
